import './Process.css';

const steps = [
  {
    num: '01',
    title: 'Discovery Call',
    desc: 'We map your goals, audience, and current marketing gaps in a focused 30-min session.',
    img: '/images/process/step1.jpg',
    points: ['Business goals & KPI mapping', 'Audience & competitor review', 'Current channel audit', 'Custom growth roadmap'],
    badge: '30 Min Session',
  },
  {
    num: '02',
    title: 'AI Strategy Build',
    desc: 'Our AI models analyze your market and generate a custom growth blueprint within 24 hours.',
    img: '/images/process/step2.jpg',
    points: ['Market & trend analysis', 'AI-generated channel mix', 'Budget allocation model', 'Content & ad blueprint'],
    badge: '24 Hr Turnaround',
  },
  {
    num: '03',
    title: 'Launch & Automate',
    desc: 'Campaigns go live within 48 hours. Automation flows activate immediately across all channels.',
    img: '/images/process/step3.jpg',
    points: ['Multi-channel campaign launch', 'AI automation flows active', 'WhatsApp & email setup', 'Live tracking dashboard'],
    badge: '48 Hr Go-Live',
  },
  {
    num: '04',
    title: 'Grow & Optimise',
    desc: 'AI monitors, learns, and scales what works. You get weekly transparent reports with clear ROI.',
    img: '/images/process/step4.jpg',
    points: ['Weekly performance reports', 'AI auto-scales winners', 'A/B test & refine', 'Ongoing strategy updates'],
    badge: 'Always On',
  },
];

export default function Process() {
  return (
    <section id="process" className="process-section">
      <div className="process-header reveal">
        <span className="section-label">How It Works</span>
        <h2 className="section-title">From Seed to Scale — <em>4 Steps</em></h2>
        <p className="section-sub">A clear, fast onboarding so you see results in days, not months.</p>
      </div>

      {/* 2x2 Grid */}
      <div className="process-grid reveal stagger">
        {steps.map((s, i) => (
          <div key={s.num} className={`process-card reveal d${i + 1}`}>
            <div className="process-card-img">
              <img src={s.img} alt={s.title} />
              <span className="process-badge">{s.badge}</span>
              <span className="process-num">{s.num}</span>
            </div>
            <div className="process-card-body">
              <h4>{s.title}</h4>
              <p>{s.desc}</p>
              <ul className="process-points">
                {s.points.map(pt => (
                  <li key={pt}><span className="pt-check">✓</span>{pt}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
